import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalMensagemDorape = _resolveComponent("ModalMensagemDorape")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mensagens, (mensagem, index) => {
      return (_openBlock(), _createBlock(_component_ModalMensagemDorape, {
        key: index,
        title: mensagem.Titulo,
        visible: _ctx.mensagens.length > 0,
        text: mensagem.Mensagem,
        id: mensagem.Id,
        onModalResult: _ctx.modalMensagemResult
      }, null, 8, ["title", "visible", "text", "id", "onModalResult"]))
    }), 128)),
    _createVNode(_component_NavBar, {
      retornaPossuiPermissao: _ctx.retornaPossuiPermissao,
      tamanho: _ctx.tamanho,
      onTrocarTema: _ctx.trocarTema
    }, null, 8, ["retornaPossuiPermissao", "tamanho", "onTrocarTema"]),
    _createVNode(_component_RouterView, {
      maiusculo: _ctx.maiusculo,
      retornaPossuiPermissao: _ctx.retornaPossuiPermissao,
      retornaDataBR: _ctx.retornaDataBR,
      retornaIdVDatePicker: _ctx.retornaIdVDatePicker,
      retornaDataUSA: _ctx.retornaDataUSA,
      tamanho: _ctx.tamanho,
      tema: _ctx.state.tema
    }, null, 8, ["maiusculo", "retornaPossuiPermissao", "retornaDataBR", "retornaIdVDatePicker", "retornaDataUSA", "tamanho", "tema"]),
    _createVNode(_component_Footer, { tamanho: _ctx.tamanho }, null, 8, ["tamanho"])
  ], 64))
}